export default __webpack_public_path__ + "static/media/sea.c90e7a0f.svg";